import { RoomIcon } from "@eisox/icons";

import { polymorphicForwardRef } from "~/types/polymorphic-forward-ref";

import { ExpandedItem, type ExpandedItemProps } from "./expended-item";

type ExpandedRoomProps = ExpandedItemProps;

const ExpandedRoom = polymorphicForwardRef<"div", ExpandedRoomProps>(
  (
    {
      backgroundColor = "blue",
      iconProps = {
        backgroundColor: "white",
        color: "darkBlue",
      },
      icon,
      ...props
    },
    ref,
  ) => (
    <ExpandedItem
      {...props}
      ref={ref}
      icon={icon !== undefined ? <RoomIcon /> : undefined}
      iconProps={iconProps}
      backgroundColor={backgroundColor}
    />
  ),
);

ExpandedRoom.displayName = "ExpandedRoom";

export default ExpandedRoom;
export { ExpandedRoom };
export type { ExpandedRoomProps };
